import React from "react";
import { Checkbox } from "antd";

const BooleanCheckboxField = (props) => (
	<Checkbox defaultChecked={props.val} disabled />
);

export default BooleanCheckboxField;
